import { IStandardTextDrawableObject } from "../../../../../../domain/editableFormat/objects";
import { IStandardTextDrawableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import {
  PrintBehaviorTranslator,
  QuoteBehaviorTranslator,
  TooltipBehaviorTranslator,
  NaturalTextBehaviorTranslator,
  GroupAlertBehaviorTranslator,
  EmptyAlertBehaviorTranslator,
  LengthAlertBehaviorTranslator,
  TextSearchBehaviorTranslator,
  FreeInputBehaviorTranslator,
  MultiLineBehaviorTranslator,
  InputRuleBehaviorTranslator,
  RelationReplacer,
  TranscribeBehaviorTranslator,
  EmptyAlertAllowBehaviorTranslator,
  GroupAlertAllowBehaviorTranslator,
  ScriptExecuteTriggerBehaviorTranslator,
  InputMethodBehaviorTranslator,
} from "../properties";
import { TextDrawableObjectTranslator } from "./TextDrawableObjectTranslator";

export class StandardTextDrawableObjectTranslator<TObject extends IStandardTextDrawableObject, TBean extends IStandardTextDrawableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new TextDrawableObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    source.printBehavior = this.printBehavior.from(bean);
    source.quoteBehavior = this.quoteBehavior.from(bean);
    source.tooltipBehavior = this.tooltipBehavior.from(bean);
    source.naturalTextBehavior = this.naturalTextBehavior.from(bean);
    source.groupAlertBehavior = this.groupAlertBehavior.from(bean);
    source.emptyAlertBehavior = this.emptyAlertBehavior.from(bean);
    source.lengthAlertBehavior = this.lengthAlertBehavior.from(bean);
    source.textSearchBehavior = this.textSearchBehavior.from(bean);
    source.freeInputBehavior = this.freeInputBehavior.from(bean);
    source.multiLineBehavior = this.multiLineBehavior.from(bean);
    source.inputRuleBehavior = this.inputRuleBehavior.from(bean);
    source.transcribeBehavior = this.transcribeBehavior.from(bean);
    source.emptyAlertAllowBehavior = this.emptyAlertAllowBehavior.from(bean);
    source.groupAlertAllowBehavior = this.groupAlertAllowBehavior.from(bean);
    source.scriptExecuteTriggerBehavior = this.scriptExecuteTriggerBehavior.from(bean);
    source.inputMethodBehavior = this.inputMethodBehavior.from(bean);
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@hide"] = this.printBehavior.to(object).hide;
    source["@quote"] = this.quoteBehavior.to(object).quote;
    source["@tooltip"] = this.tooltipBehavior.to(object).tooltip;
    source["@natural-view"] = this.naturalTextBehavior.to(object).naturalView;
    source["@natural-text"] = this.naturalTextBehavior.to(object).naturalText;
    source["@alert-group"] = this.groupAlertBehavior.to(object).alertGroup;
    source["@empty-check"] = this.emptyAlertBehavior.to(object).emptyCheck;
    source["@data-check"] = this.lengthAlertBehavior.to(object).dataCheck;
    source["@length-check"] = this.lengthAlertBehavior.to(object).lengthCheck;
    source["@search-word"] = this.textSearchBehavior.to(object).searchWord;
    source["@free-input-enable"] = this.freeInputBehavior.to(object).freeInputEnable;
    source["@type"] = this.multiLineBehavior.to(object).type;
    source["@space-line"] = "-1"; // 入力UIなし.固定らしい.
    source["@data-validation"] = this.inputRuleBehavior.to(object).dataValidation;
    this.relationReplacer.replaceBeans(source, "text-paste", this.transcribeBehavior.to(object.transcribeBehavior));
    this.relationReplacer.replaceBeans(
      source,
      "parent-alert",
      this.emptyAlertAllowBehavior.to(object.emptyAlertAllowBehavior),
      this.groupAlertAllowBehavior.to(object.groupAlertAllowBehavior));
    this.relationReplacer.replaceBeans(source, "script-link-output", this.scriptExecuteTriggerBehavior.to(object.scriptExecuteTriggerBehavior));
    source["@input-code"] = this.inputMethodBehavior.to(object).inputCode;
  }

  private readonly printBehavior = new PrintBehaviorTranslator();
  private readonly quoteBehavior = new QuoteBehaviorTranslator();
  private readonly tooltipBehavior = new TooltipBehaviorTranslator();
  private readonly naturalTextBehavior = new NaturalTextBehaviorTranslator();
  private readonly groupAlertBehavior = new GroupAlertBehaviorTranslator();
  private readonly emptyAlertBehavior = new EmptyAlertBehaviorTranslator();
  private readonly lengthAlertBehavior = new LengthAlertBehaviorTranslator();
  private readonly textSearchBehavior = new TextSearchBehaviorTranslator();
  private readonly freeInputBehavior = new FreeInputBehaviorTranslator();
  private readonly multiLineBehavior = new MultiLineBehaviorTranslator();
  private readonly inputRuleBehavior = new InputRuleBehaviorTranslator();
  private readonly transcribeBehavior = new TranscribeBehaviorTranslator();
  private readonly emptyAlertAllowBehavior = new EmptyAlertAllowBehaviorTranslator();
  private readonly groupAlertAllowBehavior = new GroupAlertAllowBehaviorTranslator();
  private readonly scriptExecuteTriggerBehavior = new ScriptExecuteTriggerBehaviorTranslator();
  private readonly relationReplacer = new RelationReplacer();
  private readonly inputMethodBehavior = new InputMethodBehaviorTranslator();
}
